import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { decodeObj } from "../Functions";
import './measurements.css';

function Clone_M({setUseSection, typeM, setSection, info}) {

    const navigate = useNavigate();

    const [coatSel, setCoatSel] = useState(false);
    const [pantSel, setPantSel] = useState(false);

    const [note, setNote] = useState("");

    const isBothSelected = coatSel && pantSel;

    const addToCart = ()=>{
        let data = decodeObj(info)
        data["measurements"] = {
            "type" : 4,
            "coat" : coatSel,
            "pant" : pantSel,
            "note" : note
        }
        
        if( Object.hasOwn(data, "id") ){
            let local = JSON.parse( localStorage.getItem("sel"))
            local.forEach((k, i)=>{
                if(k["id"] === data["id"]){
                    local[i] = data
                }
            })
            localStorage.setItem("sel", JSON.stringify(local))
        }else{
            let currC = localStorage.getItem("sel")
            if(currC && JSON.parse(currC).length > 0){
                let upC = JSON.parse(currC)
                let c = upC[upC.length - 1]["id"] + 1
                data["id"] = c
                upC.push(data)
                
                localStorage.setItem("sel", JSON.stringify(upC))
            }else{
                data["id"] = 1
                localStorage.setItem("sel", JSON.stringify([data]))
            }
        }    
    
        navigate('/cart');
    }

    return (
        <div className="clone-page">
            {/* Header Section */}
            <header className="page-header-section-clone">
                <div className="inner-wrap">
                    <h1>Clone Your Perfect Fit</h1>
                    <h2>Recreate the clothes you already love — with the exact same fit.</h2>
                    <p>If you already own a kurta, shirt, pant, or any outfit that fits you perfectly, there's no need to measure yourself again.</p>
                </div>
            </header>

            {/* How It Works Section */}
            <section className="how-it-works-section">
                <div className="inner-wrap">
                    <h3>How It Works</h3>
                    <div className="steps-wrapper">
                        <section className="step-section">
                            <div className="icon-wrapper">
                                <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 8v13H3V8"></path><path d="M1 6h22"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                                </svg>
                            </div>
                            <h4>Pickup</h4>
                            <p>We pickup your<br/>favorite garment</p>
                        </section>
                        <section className="step-section">
                            <div className="icon-wrapper">
                                <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>
                                </svg>
                            </div>
                            <h4>Stitch & Replicate</h4>
                            <p>We make a new garment<br/>with exact same measurement</p>
                        </section>
                        <section className="step-section">
                            <div className="icon-wrapper">
                                <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>
                                </svg>
                            </div>
                            <h4>Deliver</h4>
                            <p>We deliver your original<br/>and new garment together</p>
                        </section>
                    </div>
                </div>
            </section>

            {/* Main Action Section */}
            <section className="main-action-section">
                <div className="inner-wrap main-content-flex">
                    
                    <div className="instruction-box">
                        <ul className="instruction-list">
                            <li>You have selected a <strong>Coat & Pant</strong> set, so to proceed with cloning, both garments are required.</li>
                            <li>Please <strong>tick both items</strong> on the right panel to proceed.</li>
                            <li>If you want any corrections in them, mention it in the notes.</li>
                            <li>If you don't have them, select our alternate measurement options below.</li>
                        </ul>
                    </div>

                    <div className="action-box">
                        
                        <div className="garment-selection">
                            
                            {/* COAT BOX */}
                            <div 
                                className={`garment-item ${coatSel ? 'selected' : ''}`}
                                onClick={() => setCoatSel(!coatSel)}
                            >
                                <span className="top-label">Yes I have</span>
                                <svg width="45" height="45" viewBox="0 0 24 24">
                                    <path d="M8 2h8l3 7-1 13h-4v-9h-4v9H5l-1-13 3-7z"></path>
                                    <path d="M8 2l4 10 4-10"></path><path d="M6 9l6 7 6-7"></path><path d="M12 12v10"></path>
                                </svg>
                                <span className="main-label">Coat</span>
                                <div className="selected-dot"></div>
                            </div>

                            {/* PANT BOX */}
                            <div 
                                className={`garment-item ${pantSel ? 'selected' : ''}`}
                                onClick={() => setPantSel(!pantSel)}
                            >
                                <span className="top-label">Yes I have</span>
                                <svg width="45" height="45" viewBox="0 0 24 24">
                                    <path d="M7 3h10l-1 18h-4l-1-12-1 12H8L7 3z"></path>
                                    <path d="M9.5 3v15"></path><path d="M14.5 3v15"></path><path d="M7 5h10"></path>
                                </svg>
                                <span className="main-label">Pant</span>
                                <div className="selected-dot"></div>
                            </div>

                        </div>

                        <div className="note-container">
                            <label>Note (Optional)</label>
                            <textarea 
                                className="note-textarea" 
                                placeholder="Mention any corrections or specific instructions here..."
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                            ></textarea>
                        </div>

                        {/* PROCEED BUTTON */}
                        <button 
                            className="btn-proceed" 
                            disabled={!isBothSelected}
                            onClick={addToCart}
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '8px'}}>
                                {isBothSelected ? (
                                    <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></>
                                ) : (
                                    <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path></>
                                )}
                            </svg>
                            Proceed
                        </button>
                        
                        <div className="care-text">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>
                            </svg>
                            Your garment will be handled with utmost care
                        </div>

                        <div className="divider"><span>or</span></div>

                        <div className="alt-buttons-wrapper">
                            <button className="btn-alt" onClick={() => navigate(`/measurement/custom/${info}`)}>Custom measurement</button>
                            <button className="btn-alt" onClick={() => navigate(`/measurement/size_chart/${info}`)}>By size chart</button>
                            <button className="btn-alt" onClick={() => navigate(`/measurement/saved/${info}`)}>Saved Measurement</button>
                        </div>

                    </div>
                </div>
            </section>

        </div>
    );
}

export default Clone_M;